import { Box, Typography, useTheme } from '@mui/material';
import { Pill } from '@care/react-component-lib';
import { Caregiver } from '@/types';

const CaregiverCardBack = ({
  card,
  isVisible,
  isFading,
}: {
  card: Caregiver;
  isVisible: boolean;
  isFading: boolean;
}) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="caregiver-card-back"
      sx={{
        padding: theme.spacing('28px', '18.5px'),
        backgroundColor: theme.palette.background.green,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        position: 'absolute ',
        top: 0,
        left: 0,
        ...(!isVisible && {
          opacity: 0,
        }),
        ...(isFading && {
          opacity: isVisible ? 0 : 1,
          transition: 'opacity 0.5s ease-in-out',
        }),
      }}>
      <Box
        sx={{
          color: `${theme.palette.text.brand}`,
        }}>
        <Typography variant="h4">{card.review.description}</Typography>
        <Typography mt={2} variant="h4">
          {card.review.name}
        </Typography>
      </Box>

      <Box
        sx={{
          color: `${theme.palette.text.primary}`,
        }}>
        <Typography variant="h3">Can help with</Typography>
        <Box
          sx={{
            mt: 2,
            gap: 1,
            display: 'flex',
            flexWrap: 'wrap',
          }}>
          {card.servicesOffered.map((service) => (
            <Pill
              label={service}
              key={service}
              value={service}
              size="sm"
              sx={{
                backgroundColor: theme.palette.background.default,
                borderRadius: 4,
                '& :hover': {
                  backgroundColor: theme.palette.background.default,
                  cursor: 'default',
                },
                '&.MuiListItem-root': {
                  mb: 0,
                  width: 'fit-content',
                },
                '& label.MuiBox-root': {
                  boxShadow: 'none',
                  height: '32px',
                  padding: theme.spacing(0, '12px'),
                },
                '& .MuiTypography-root': {
                  fontSize: '14px',
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default CaregiverCardBack;
